module.exports = __webpack_public_path__ + "img/35B.9945d9e6.png";